import React from "react";
import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import Testimonials from "../../components/Testimonials/Testimonials";
import FAQ from "../../components/FAQ/FAQ";
import Footer from "../../components/Footer/Footer";
import "./Home.css";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Testimonials />
      <FAQ />
      <Footer />
    </>
  );
};

export default Home;
